import React from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import AttachmentDataMiniTable from './AttachmentDataMiniTable';

// MUI transitions
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';

export default class AttachmentDataRemoval extends React.Component {
  constructor(props) {
    super(props);
  }

  baseUrl = `/api/attachments`;

  handleAttachmentOrdersRemoval = async (event) => {
    event.preventDefault();

    const attachments = this.props.attachments;
    if (!this.props.removable || !attachments || attachments.length < 1) return;

    const attachmentIds = attachments.map(attachment => attachment.id);
    const csrfToken = document.querySelector('[name=csrf-token]').content;

    let url = '';
    let req = {};
    if (attachmentIds.length > 1) { // Batch delete API for multiple attachments
      url = this.baseUrl + '/batch_delete';
      req = {
        method: 'POST',
        body: JSON.stringify({ attachment_ids: attachmentIds }),
        headers: {
          "Content-type": "application/json; charset: UTF-8",
          'X-CSRF-Token': csrfToken
        }
      };
    }
    else {
      url = this.baseUrl + '/' + attachmentIds[0];
      req = {
        method: 'DELETE',
        headers: {
          "Content-type": "application/json; charset: UTF-8",
          'X-CSRF-Token': csrfToken
        }
      };
    }

    try {
      const response = await fetch(url, req);
      if (response.status >= 400) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log(`${attachmentIds.length > 1 ? 'Batch delete' : 'Delete'} result:`, result);

      this.props.onClose();
      if (this.props.tableRef.current) {
        this.props.tableRef.current.onQueryChange();
      }
    } catch (err) {
      console.error(`${attachmentIds.length > 1 ? 'Batch delete' : 'Delete'} error:`, err);
      return;
    }
  };

  // =====================
  // Render Component
  // =====================
  render() {
    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={this.props.open} timeout={500}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            bgcolor="#fff"
            p={4}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              outline: 'none',
              borderRadius: '4px',
              minWidth: '300px'
            }}
          >
            <form onSubmit={this.handleAttachmentOrdersRemoval}>
              <Typography variant="h6" gutterBottom>
                Are you sure you want to delete selected attachment(s)?
              </Typography>

              {this.props.attachments && this.props.attachments.length > 0 &&
                <AttachmentDataMiniTable attachments={this.props.attachments} />
              }

              <Box className="d-flex justify-content-end">
                <Button
                  variant="outlined"
                  onClick={this.props.onClose}
                  className="mr-2"
                >
                  Cancel
                </Button>
                {this.props.removable &&
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#d93939ff" }}
                    disabled={!this.props.attachments || this.props.attachments.length < 1}
                    className="mr-2"
                    type="submit"
                  >
                    Delete
                  </Button>
                }
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>
    );
  }
}
